import React, { ImgHTMLAttributes, useEffect, useState } from 'react'
import defaultImg from '@/assets/images/img_all.png'

interface DefaultImgProps extends ImgHTMLAttributes<any> {}

const DefaultImg: React.FC<DefaultImgProps> = props => {
  const { src = defaultImg, ...rest } = props
  const [imgSrc, setImgSrc] = useState(src)

  useEffect(() => {
    setImgSrc(src)
  }, [src])

  const onError = () => {
    setImgSrc(defaultImg)
  }

  return <img alt="" src={imgSrc} onError={onError} {...rest} />
}

export default DefaultImg
